import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';
const ReviewProvider = (props) => {
  const api = new API();
  const [reviewClinicData, setReviewClinicData] = useState({});
  const [reviewClinicLoader, setReviewClinicLoader] = useState(false);
  const [reviewPostLoader, setReviewPostLoader] = useState(false);
  const [reviewStep, setReviewStep] = useState(1);
  const [reviewPostForm] = Form.useForm();
  const fetchReviewSingleClinic = async (id) => {
    setReviewClinicLoader(true);
    (await api.getSingle("review/single", id, (err, res) => {
      if (res?.data?.status === 200) {
        setReviewClinicData(res?.data?.data);
        setReviewClinicLoader(false);
      } else {
        setReviewClinicData({});
        setReviewClinicLoader(false);
      }
    }));
  }
  const postReview = async (data,navigate=null) => {
    setReviewPostLoader(true);
    (await api.create("review/add", data, (err, res) => {
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        reviewPostForm.resetFields();
        setReviewStep(2);
        navigate && navigate();
        setReviewPostLoader(false);
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
        setReviewPostLoader(false);
      }
    }));
  }
  return (
    <Context.Provider value={{
      ...props,
      reviewClinicData, setReviewClinicData,
      reviewClinicLoader, setReviewClinicLoader,
      fetchReviewSingleClinic,
      postReview,
      reviewPostLoader, setReviewPostLoader,
      reviewStep, setReviewStep,
      reviewPostForm
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default ReviewProvider;
